import React from "react";
import { Link, useHistory } from "react-router-dom";
import "./TeslaAccount.css";
import { logout, selectUser } from "./features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import MenuIcone from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Car from "./Car";
import { auth } from "./firebase";

function TeslaAccount({ isMenuOpen, setIsMenuOpen }) {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const history = useHistory();

  // when ever we sign out we have to remove the data from there thats why we use dispatch
  const logOutOfApp = () => {
    auth
      .signOut()
      .then(() => {
        dispatch(logout());
        history.push("/"); // push back to the home page
      })
      .catch((error) => alert(error.message));
  };
  return (
    <div className="teslaAccount">
      <div className="teslaAccount__header">
        <div className="teslaAccount__logo">
          <Link to="/">
            <img
              //will change the logo on top on the tab
              src="https://assets.website-files.com/5e8fceb1c9af5c3915ec97a0/5ec2f037975ed372da9f6286_Tesla-Logo-PNG-HD.png"
              alt=""
            />
          </Link>
        </div>
        {/*these are the header links or tabs */}
        <div className="teslaAccount__links">
          <Link to="/teslaaccount">Model S</Link>
          <Link to="/teslaaccount">Model 3</Link>
          <Link to="/teslaaccount">Model X</Link>
          <Link to="/teslaaccount">Model Y</Link>
          <Link to="/teslaaccount">Solar Roof</Link>
          <Link to="/teslaaccount">Solar Panels</Link>
          <Link to="/teslaaccount">Shop</Link>
          <Link to="/teslaaccount">Tesla Account</Link>
          {/*will logout*/}
          <Link to="/" onClick={logOutOfApp}>
            Log Out{" "}
          </Link>
          <div
            className="teslaAccount__menu"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <CloseIcon className="teslaAccount__closeMenu" />
            ) : (
              <MenuIcone />
            )}
          </div>
        </div>
      </div>

      <div className="teslaAccount__info">
        <div className="teslaAccount_person">
          <h4>{user?.displayName + "'s"} Tesla</h4>
        </div>

        <div className="teslaAccount__infoRight">
          <Link>Home</Link>
          <Link>Account</Link>
          <Link>History</Link>
          {/* will logout the user */}
          <Link to="/" onClick={logOutOfApp}>
            Sign Out
          </Link>
        </div>
      </div>
      {/* Componenets are really good they can save us so much time and code */}
      {/* with compoenets we can create miltiple different class with one JS compnent */}
      {/* ex: */}
      <div className="teslaaccount__car">
        <Car
          imgSrc="https://www.tesla.com/tesla_theme/assets/img/mytesla/v3/header-nocar-models@2x.jpg?20170815"
          model="Model S"
          testDrive
        />
        <Car
          imgSrc="https://www.tesla.com/tesla_theme/assets/img/mytesla/v3/header-nocar-modelx@2x.jpg?20170815"
          model="Model X"
        />
      </div>
    </div>
  );
}

export default TeslaAccount;
